import xss from 'xss'
import Vue from 'vue';

Object.defineProperty(Vue.prototype, '$xss', {
  value: xss,
});
